module.exports = __webpack_public_path__ + "img/板2.57e08bd9.png";